import { gql, useQuery } from '@apollo/client';
import { GetOpenAiProcessesQuery } from '../../__generated__/queries-web';

export const GET_USER_OPEN_AI_PROCESSES = gql`
  query GetOpenAiProcesses {
    openAiProcesses(first: 100, orderBy: id_DESC) {
      article {
        id
      }
      id
      slideshowSubject
      recipeNumber
      status
      errorMsg
      createdAt
      updatedAt
      generatedTitle
    }
  }
`;

export const useGetUserOpenAiProcesses = () =>
  useQuery<GetOpenAiProcessesQuery>(GET_USER_OPEN_AI_PROCESSES);
